import { getHistoricalDataCourts, modifySourceUpdateInterval } from '../api/GetHistoricalData';
const requestHistoricalDataType = 'REQUEST_HISTORICAL_DATA';
const receiveHistoricalDataType = 'RECEIVE_HISTORICAL_DATA';

const afterModifiedUpdateIntervalType = 'AFTER_MODIFIED_UPDATE_INTERVAL';

const initialState = { historicalData: [], isLoading: false };

export const actionCreators = {
    requestHistoricalData: () => async (dispatch, getState) => {

        if (getState().historicalData.historicalData.length > 0 || getState().historicalData.isLoading) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: requestHistoricalDataType });

        getHistoricalDataCourts().then(data => {
            dispatch({ type: receiveHistoricalDataType, historicalData: data });
        }).catch(ex => {
            // todo
        });                
    },
    modifySourceUpdateInterval: (ossId, courtUid, updateInterval) => async (dispatch, getState) => {
        modifySourceUpdateInterval(ossId, courtUid, updateInterval).then(() => {
            
        }).catch(ex => {

        })
    },
};  

export const manualDispatchActions = {
    updateSourceInterval: (dispatch, ossId, courtUid, updateInterval) => {
        dispatch({ type: afterModifiedUpdateIntervalType, modifiedValues: { ossId, courtUid, updateInterval } });
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestHistoricalDataType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveHistoricalDataType) {
        return {
            ...state,
            historicalData: action.historicalData,
            isLoading: false
        };
    }

    if (action.type === afterModifiedUpdateIntervalType) {
        let existingHistoricalData = [...state.historicalData];
        var modifiedItem = existingHistoricalData.filter(i => i.ossId == action.modifiedValues.ossId && i.courtUid == action.modifiedValues.courtUid)[0];
        if (modifiedItem != null) {
            modifiedItem.updateInterval = action.modifiedValues.updateInterval;
        }
        
        return {
            ...state,
            historicalData: existingHistoricalData
        }
    }

    return state;
};
